import './Poets.css'
import React, { useEffect, useState } from 'react';
import Card from '../Card-poet/Card';
import Details from '../Details-cart/Details';

const Poets = () => {
    const [poets, setPoet] = useState([]);
    const [details, setDetails] = useState([]);
    useEffect(() =>{
            fetch('./poets.JSON')
            .then(res=> res.json())
            .then(data=> setPoet(data))
    }, [])

    const cartDetailsHandel = (poet) =>{
        const newDetails = [...details, poet];
        setDetails(newDetails);
    }
    return (
        <div className="poets">
            <div className="poet1">
                {
                    poets.map(poet => <Card
                                        key = {poet.key} 
                                        poet = {poet}
                                        cartDetailsHandel={cartDetailsHandel}></Card>)
                }
            </div>
            <div className="poet2">
                <div className="poet2-title">
                <Details
                    details={details}></Details>
                </div> 
            </div>
        </div>
    );
};

export default Poets;